import styled from 'styled-components'

import bulbIco from './bulb-ico.svg'

export const Container = styled.div<{ $icon?: string }>`
  background: url(${bulbIco}) no-repeat 0 3px;
  background: ${(props) => (props.$icon ? `url(${props.$icon}) no-repeat 5px 3px` : `url(${bulbIco}) no-repeat 0 3px`)};
  color: ${({ theme }) => theme.colors.font.dark};
  text-align: left;
  padding-left: 30px;
  font-size: 14px;
`

export const Message = styled.div`
  margin: 0;
`
